module.exports = __webpack_public_path__ + "img/down@2x.0a41398d.svg";